import React from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const items = [
  { key: "/calculator", label: "计算器" },
  { key: "/history", label: "历史数据" }
];

export default function NavigationTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeKey = location.pathname.startsWith("/history") ? "/history" : "/calculator";

  return (
    <div className="nav-wrap">
      <Tabs
        centered
        activeKey={activeKey}
        items={items}
        onChange={(key) => navigate(key)}
      />
    </div>
  );
}
